<div
  ngbTooltip="{{ time | date: 'MMM dd, y HH:mm:ss Z' }}"
  placement="{{ placement }}"
  container="body"
>
  <span class="text-dotted" *ngIf="label">{{ label }}</span
  ><span class="text-dotted" *ngIf="!label">
    <ab-time-ago [time]="time"></ab-time-ago
  ></span>
</div>
